import { defineStyleConfig } from "@chakra-ui/react";

const Input = defineStyleConfig({
  variants: {
    outline: {
      field: {
        borderRadius: "var(--chakra-radii-xl)",
        fontSize: "sm",
        height: "var(--chakra-sizes-14)",
        border: "1px solid",
        _hover: {
          borderColor: "primary.300",
        },
        _focus: {
          borderColor: "primary.300",
        },
        background: "transparent",
      },
      addon: {
        background: "secondary.400",
        color: "secondary.50",
        height: "var(--chakra-sizes-14)",
        borderRadius: "var(--chakra-radii-xl)",
      },
    },
  },
});

export default Input;
